import { ROLE } from 'services/assist-api/entities/role/roles';
import { hasRole } from './helpers';
import type { AuthorisableUser } from './types';

export const markingAllocationRoles = [ROLE.SITE_ADMIN, ROLE.ADMIN, ROLE.MARKING_ADMIN];

// Helper functions (don't use these directly for authorising actions; use a policy action):
export function hasMarkingAllocationRole(user: AuthorisableUser): boolean {
  return hasRole(user, markingAllocationRoles);
}

/**
 * Authorisation rules for the resource that the policy is named after.
 * Functions return true only if the user can perform the action.
 * Follows the policy pattern used in Gate (Laravel) and Pundit (Rails).
 */
export default class MarkingAllocationPolicy {
  static allocate(user: AuthorisableUser): boolean {
    if (!user.belongsToMarkingOrganisation) return false;
    return hasMarkingAllocationRole(user);
  }
}
